import styled from 'styled-components';
import { theme } from '../layout/theme';

export const IconContainer = styled.span`
  color: ${theme.colors.ui.positive};
  font-size: 22px;

  &.low {
    color: ${theme.colors.ui.neutral};
  }

  &.alt {
    color: ${theme.colors.ui.info};
  }

  &.unavailable {
    color: ${theme.colors.ui.negative};
  }

  &.unknown {
    color: ${theme.colors.ui.unknown};
  }
`;
